import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { Features } from "../components/features";
import { Footer } from "../components/Footer";
import { Generic } from "../components/Generic";
import { Contact } from "../components/contact";
import JsonData from "../data/data.json";
import Navbar from "../components/Navbar";

const Home = () => {
  const [landingPageData, setLandingPageData] = useState({});
  const [deviceInfo, setDeviceInfo] = useState("");
  const location = useLocation();

  // Evita doble ejecución en desarrollo con StrictMode
  const scrolledRef = useRef(false);

  // Scroll a la sección cuando la ruta sea #/contact o ?scroll=contact
  useEffect(() => {
    const wantsContact =
      location.pathname === "/contact" ||
      window.location.hash.includes("/contact") ||
      new URLSearchParams(location.search).get("scroll") === "contact";

    if (!wantsContact || scrolledRef.current) return;

    const tryScroll = () => {
      const el = document.getElementById("contact");
      if (!el) return false;
      el.scrollIntoView({ behavior: "smooth", block: "start" });
      scrolledRef.current = true;
      return true;
    };

    // Intento inmediato
    if (tryScroll()) return;

    // Reintentos mientras se monta contenido
    const observer = new MutationObserver(() => {
      if (tryScroll()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    const timeoutId = setTimeout(() => observer.disconnect(), 5000);

    return () => {
      observer.disconnect();
      clearTimeout(timeoutId);
    };
  }, [location.pathname, location.search]);

  // Tu lógica actual
  const debounce = (func, delay) => {
    let timeoutId;
    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        func(...args);
      }, delay);
    };
  };

  useEffect(() => {
    const handleResize = () => {
      const userAgent = navigator.userAgent;
      const width = window.innerWidth;
      const height = window.innerHeight;
      let deviceType = "Computer";
      if (/Android/i.test(userAgent)) {
        deviceType = "Android";
      } else if (/iPhone|iPad|iPod/i.test(userAgent)) {
        deviceType = "iPhone";
      }
      setDeviceInfo({ device: deviceType, height: height, width: width });
    };
    setLandingPageData(JsonData);
    const debouncedHandleResize = debounce(handleResize, 300);
    window.addEventListener("resize", debouncedHandleResize);
    return () => window.removeEventListener("resize", debouncedHandleResize);
  }, []);

  const small = window.innerWidth < 992;

  return (
    <div style={{ cursor: "auto", fontSize: "14px" }}>
      <Navbar />

      <header id="header">
        <div className="intro" style={{ marginTop: "100px" }}>
          <div className="overlayH">
            <Generic
              id={"Header"}
              side={"l"}
              data={landingPageData.Makeup}
              device={deviceInfo}
            />
          </div>
        </div>
      </header>

      <Generic
        id={"Clothing"}
        side={small ? "l" : "r"}
        data={landingPageData.Makeup}
        device={deviceInfo}
      />
      <Generic
        id={"Hair"}
        side={"l"}
        data={landingPageData.Makeup}
        device={deviceInfo}
      />
      <Generic
        id={"Makeup"}
        side={small ? "l" : "r"}
        data={landingPageData.Makeup}
        device={deviceInfo}
      />

      <div className="intro">
        <Generic
          id={"Capture"}
          side={"l"}
          data={landingPageData.Makeup}
          device={deviceInfo}
        />
      </div>

      <Generic
        id={"Combos"}
        side={small ? "l" : "r"}
        data={landingPageData.Makeup}
        device={deviceInfo}
      />
      <Features data={landingPageData.Features} />

      {/* Ancla visible y estable para el scroll */}
      <div id="contact">
        <Contact />
      </div>

      <Footer device={deviceInfo} />
    </div>
  );
};

export default Home;
